import { OneWayInServiceDto } from 'src/api/v2';

const getInitialMessageHtml = (
  activeClusterServices: OneWayInServiceDto[],
  selectedServiceIds: string[],
  customerName: string | undefined,
  userEmail: string | undefined,
  userPhone: string | undefined,
  displayName: string | undefined,
  clusterName: string | undefined,
) => {
  const services = selectedServiceIds
    .map((id) => {
      const service = activeClusterServices.find((service) => service.id === id);
      if (!service) return '';

      const description = service.customerDescription ?? '';

      return `<p><strong>${service?.name}</strong><br>${description}</p>`;
    })
    .join('<br>');

  const contactInfo = userEmail
    ? userPhone
      ? `<p>Ta kontakt på ${userEmail} eller ${userPhone} hvis du har noen spørsmål.</p><br>`
      : `<p>Ta kontakt på ${userEmail} hvis du har noen spørsmål.</p><br>`
    : '';

  const greeting = customerName ? `Hei, ${customerName},` : 'Hei,';

  return `<p>${greeting}</p><br>
<p>Vi vil gjerne anbefale deg følgende tjenester hos oss:</p>
${services}
<br>
${contactInfo}
<p>Med vennlig hilsen<br>
<strong>${displayName}</strong><br>
${clusterName}</p>`;
};

export default getInitialMessageHtml;
